import React  from 'react'
import type { ToastProps } from './Toast'

interface ToastContextProps {
  getToasts: () => Map<string, ToastProps> | undefined
  getToast: (key: string) => ToastProps | undefined
  addToast: (toast: ToastProps) => void
  removeToast: (key: string) => void
}

const ToastContext = React.createContext<ToastContextProps>({
  getToasts: () => undefined,
  getToast: () => undefined,
  addToast: () => {},
  removeToast: () => {},
})

export function useToast() {
  return React.useContext(ToastContext)
}

export default ToastContext
